module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26882",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6946",
      "conversations-error-reporting": "static-1.8220",
      "conversations-internal-pub-sub": "static-1.15304",
      "conversations-internal-schema": "static-1.11947",
      "conversations-message-history": "static-1.10468",
      "conversations-test-sdk": "static-1.9759",
      "conversations-visitor-experience-components": "static-1.20245",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4825",
      "hs-test-utils": "static-1.7307",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10815",
      "I18n": "static-7.1447",
      "jasmine-immutable": "static-1.2266",
      "jasmine-runner": "static-1.5725",
      "quartz": "static-1.6102",
      "react-dlb": "static-1.61",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.75",
      "urlinator": "static-1.3839",
      "viral-links-lib": "static-1.6205",
      "visitor-ui-component-library": "static-1.5474",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3867",
      "atom": "static-1.4451",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4093",
      "conversations-infrastructure": "static-1.8240",
      "conversations-prop-types": "static-1.6746",
      "conversations-visibility-tools": "static-1.5071",
      "conversations-visitor-message-history": "static-1.18982",
      "cssUtils": "static-1.593",
      "enviro": "static-4.328",
      "flux-actions": "static-1.285",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15891",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4707",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3677",
      "sanitize-text": "static-1.7452",
      "signup-constants": "static-1.17410",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.475",
      "usage-tracker": "static-1.6743",
      "usage-tracker-core": "static-1.6593",
      "usage-tracker-multi": "static-1.5157",
      "usage-tracker-public": "static-1.6554",
      "visitor-ui-component-library-icons": "static-1.5285",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2854",
      "moment": "static-3.26",
      "quartz-core": "static-1.5321",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4173",
      "foundations-components": "static-1.6790",
      "foundations-theming": "static-1.3638",
      "UIComponents": "static-3.7762",
      "cv-backend-services": "static-1.1323",
      "immutable-less": "static-1.3860",
      "conversations-skeleton-state": "static-1.6664",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.80",
      "rpc-client-utils": "static-1.4008",
      "ui-images": "static-2.958",
      "permission-components": "static-1.4658",
      "HeadJS": "static-2.620",
      "framer-motion": "static-1.51",
      "hs-test-utils-bend-plugin": "static-1.2418",
      "msw": "static-1.39",
      "testing-library": "static-1.133",
      "i18n-data": "static-1.207",
      "moment-timezone": "static-5.66",
      "jasmine": "static-4.3626",
      "quartz-core-utils": "static-1.2969",
      "signup-ui-url-generator": "static-2.7376",
      "HubStyle": "static-2.11123",
      "sassPrefix": "static-1.139",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5160",
      "dispatcher": "static-1.120",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.694",
      "hub-http-shared-msw-handlers": "static-1.8285",
      "hubspotter-http": "static-1.3970",
      "hubspotter-http-shared-msw-handlers": "static-1.8283",
      "mobile-manifest-mixins": "static-1.391",
      "platform-navigation-bootstrap": "static-1.11786",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8666",
      "bend-plugin-foundations-components": "static-1.3059",
      "floating-ui": "static-1.39",
      "foundations-theming-specialty": "static-1.1354",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2121",
      "foundations-theming-base": "static-1.2623",
      "ts-schema": "static-1.3496",
      "platform-infra-nav-components": "static-1.7080"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26882",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6946",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8220",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15304",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11947",
      "conversations-message-history": "/conversations-message-history/static-1.10468",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9759",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20245",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4825",
      "hs-test-utils": "/hs-test-utils/static-1.7307",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10815",
      "I18n": "/I18n/static-7.1447",
      "jasmine-immutable": "/jasmine-immutable/static-1.2266",
      "jasmine-runner": "/jasmine-runner/static-1.5725",
      "quartz": "/quartz/static-1.6102",
      "react-dlb": "/react-dlb/static-1.61",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.75",
      "urlinator": "/urlinator/static-1.3839",
      "viral-links-lib": "/viral-links-lib/static-1.6205",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5474",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3867",
      "atom": "/atom/static-1.4451",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4093",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8240",
      "conversations-prop-types": "/conversations-prop-types/static-1.6746",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5071",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18982",
      "cssUtils": "/cssUtils/static-1.593",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.285",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15891",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4707",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3677",
      "sanitize-text": "/sanitize-text/static-1.7452",
      "signup-constants": "/signup-constants/static-1.17410",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.475",
      "usage-tracker": "/usage-tracker/static-1.6743",
      "usage-tracker-core": "/usage-tracker-core/static-1.6593",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5157",
      "usage-tracker-public": "/usage-tracker-public/static-1.6554",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5285",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2854",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5321",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4173",
      "foundations-components": "/foundations-components/static-1.6790",
      "foundations-theming": "/foundations-theming/static-1.3638",
      "UIComponents": "/UIComponents/static-3.7762",
      "cv-backend-services": "/cv-backend-services/static-1.1323",
      "immutable-less": "/immutable-less/static-1.3860",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6664",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.80",
      "rpc-client-utils": "/rpc-client-utils/static-1.4008",
      "ui-images": "/ui-images/static-2.958",
      "permission-components": "/permission-components/static-1.4658",
      "HeadJS": "/HeadJS/static-2.620",
      "framer-motion": "/framer-motion/static-1.51",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2418",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.133",
      "i18n-data": "/i18n-data/static-1.207",
      "moment-timezone": "/moment-timezone/static-5.66",
      "jasmine": "/jasmine/static-4.3626",
      "quartz-core-utils": "/quartz-core-utils/static-1.2969",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7376",
      "HubStyle": "/HubStyle/static-2.11123",
      "sassPrefix": "/sassPrefix/static-1.139",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5160",
      "dispatcher": "/dispatcher/static-1.120",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.694",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8285",
      "hubspotter-http": "/hubspotter-http/static-1.3970",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8283",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.391",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11786",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8666",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3059",
      "floating-ui": "/floating-ui/static-1.39",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1354",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2121",
      "foundations-theming-base": "/foundations-theming-base/static-1.2623",
      "ts-schema": "/ts-schema/static-1.3496",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7080"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};